<template>
  <!-- Reset Password Component -->
  <v-container>
    <v-row align="center" justify="center" width="800">
      <v-col cols="12" xl="6" lg="6" md="6" sm="12">
        <v-card color="primary">
          <v-card-title>
            {{get("header-1")}}
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import apiService from "@/_services/api-service";
import { Status } from "@/constants";
import localizationMixin from "@/mixins/localization-mixin";
import store from "@/store";
import router from "@/router";
import breakpointMixin from "../../mixins/breakpointMixin";

export default {
  name: "Login",
  components: {
  },

  created() {
    this.pageName = "reset";
  },

  data: () => ({
    email: "",
    emailRules: [(v) => !!v || "Email is required"],
    valid: false,
  }),

  mixins: [breakpointMixin, localizationMixin],

  methods: {
    onForgotUsername() {
      router.push("/account/forgot");
    },
    getLocalization(){},
    onLogin() {
      router.push("/account/login");
    },
    onRegister() {
      router.push("/account/register");
    },
    onResetPassword() {
      const url = "account/reset/" + this.email;
      apiService.post(url, {}, this.successCallback, this.errorCallback);
    },

    successCallback(response) {
      const notification = {
        title: "Reset Password",
        status: Status.success,
        messages: [response.data],
      };
      store.commit("setNotification", notification);
    },

    errorCallback(response) {
      const notification = {
        title: "Reset Password",
        status: "error",
        messages: [response.data],
      };
      store.commit("setNotification", notification);
    },
  },

  store,
  router,
};
</script>
<style lang="scss" scoped>
.v-card {
  margin-right: 15px;
}

.v-btn {
  margin-bottom: 20px;
  margin-left: 10px;
}
</style>
